/* eslint-disable react/require-default-props */
import React from 'react';
import UiSizes from '@enums/UiSizes';
export default function LetterAvatar({ letter, backgroundColor, size = UiSizes.medium }) {
    return (React.createElement("span", { className: `qmb-avatar--${size}` },
        React.createElement("svg", { viewBox: "0 0 16 16" },
            React.createElement("circle", { cx: "8", cy: "8", r: "8", style: { fill: backgroundColor } }),
            React.createElement("text", { x: "50%", y: "55%", dominantBaseline: "middle", textAnchor: "middle" }, letter))));
}
